export default __webpack_public_path__ + "static/media/credit-white-icon.e85a3504.png";